// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__1yGxH","full":"Container_full__2q8iG","wide":"Container_wide__19JHD"};